import { SubscriptionName } from '@anm/api/modules/subscription';

const isAppSumoSubscription = (subscription: SubscriptionName) =>
  subscription.includes('AppSumo');

export default isAppSumoSubscription;
